import script from "./HistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryList.vue?vue&type=script&setup=true&lang=js"

import "./HistoryList.vue?vue&type=style&index=0&id=a2c0da82&lang=scss"

const __exports__ = script;

export default __exports__